module.exports = "https://static.zego.com/_next/static/images/hero-broker-landing-page-medium-99e17a691714b21cb52060b0ad070b1d.png";